/**
 * Initialize and contorls the job filters
 * @type {JobPostingFilter}
 */
export class JobPostingFilter {
    multiValueSeparator = ', '

    constructor() {
        // filter wrapper container
        this.filterWrapper = document.querySelector('.js__job-filter-wrapper')
        // job postings wrapper container
        this.jobItemsWrapper = document.querySelector('.js__job-items-wrapper')
        // all listed job items
        this.jobItems = document.querySelectorAll('.js__job-item')
        // initialize events and filter groups
        if (this.jobItems && this.filterWrapper) {
            this.initializeFilterTables()
        }
    }

    /**
     * Initialize the filters and add event listeners
     */
    initializeFilterTables() {
        var filterGroups = this.filterWrapper.children
        // draw the filter tables and initialize click and filter events
        this.drawFilterTables()
        // add opening event to filter groups
        for (let filterGroup of filterGroups) {
            filterGroup.addEventListener('click', function () {
                if (filterGroup.classList.contains('group-active')) {
                    filterGroup.classList.remove('group-active')
                } else {
                    for (let filterGroup of filterGroups) {
                        if (filterGroup.classList.contains('group-active')) {
                            filterGroup.classList.remove('group-active')
                        }
                    }
                    filterGroup.classList.add('group-active')
                }
            })
        }
        // close dropdown when open and clicked outside
        document.addEventListener('click', function (event) {
            for (let filterGroup of filterGroups) {
                let isClickInsideElement = filterGroup.contains(event.target)
                if (!isClickInsideElement) {
                    if (filterGroup.classList.contains('group-active')) {
                        filterGroup.classList.remove('group-active')
                    }
                }
            }
        })
    }

    /**
     * Get all data from the given jobs and draw filter tables
     */
    drawFilterTables() {
        let availablePositions = []
        let availableLocations = []
        // Get all data attributes from the job items
        for (let jobItem of this.jobItems) {
            if (jobItem.dataset.position) {
                availablePositions.push(jobItem.dataset.position)
            }
            if (jobItem.dataset.location) {
                // support of multi location job
                let locationData = jobItem.dataset.location
                if (locationData) {
                    locationData.split(this.multiValueSeparator).forEach(function (location) {
                        availableLocations.push(location)
                    })
                }
            }
        }
        // add items to filter group -> we need to add new filter groups manually
        this.addElementToFilterTable(this.getUniqueDataArrays(availablePositions), 'Position')
        this.addElementToFilterTable(this.getUniqueDataArrays(availableLocations), 'Location')
    }

    /**
     * Add elements to filter group and add filter event
     * @param distinctData
     * @param groupName
     */
    addElementToFilterTable(distinctData, groupName) {
        // Get the correct filter group
        let filterGroup = document.querySelector(`[data-vocabulary="${groupName}"]`)
        let filterContent = filterGroup.children[2]
        // Insert filter attribute into table and add filter event
        for (let filterAttribute of distinctData) {
            // Create html elements
            let filterItem = this.createElementFromHTML("<div class='filter-item'></div>")
            let checkbox = this.createElementFromHTML(
                '<input type="checkbox" data-vocabulary="' +
                    groupName +
                    '" id="' +
                    filterAttribute +
                    '" name="' +
                    filterAttribute +
                    '">'
            )
            let label = this.createElementFromHTML(
                '<label for="' + filterAttribute + '">' + filterAttribute + '</label>'
            )
            // Add filter event when checkbox changeg
            checkbox.addEventListener('change', () => {
                this.updateFilter()
            })
            // Append new created elements to parent
            filterItem.append(checkbox)
            filterItem.append(label)
            filterContent.append(filterItem)
        }
    }

    /**
     * Make array distinct
     * @param dataArray
     * @returns {array}
     */
    getUniqueDataArrays(dataArray) {
        const unique = (value, index, self) => {
            return self.indexOf(value) === index
        }
        return dataArray.filter(unique)
    }

    /**
     * Add data to filter cache and refilter
     */
    updateFilter() {
        // Create filter cache
        let filterVocabulary = []
        let selectedFilterElements = []
        // Get all filter items
        let filterContentGroups = document.querySelectorAll('.js__group-items')
        // Now check if a checkbox is checked and add to filterCache
        for (let contentGroup of filterContentGroups) {
            let contentItems = contentGroup.children
            for (let contentItem of contentItems) {
                let checkbox = contentItem.children[0]
                if (checkbox.checked) {
                    if (filterVocabulary[checkbox.dataset.vocabulary] === undefined) {
                        filterVocabulary[checkbox.dataset.vocabulary] = []
                    }
                    filterVocabulary[checkbox.dataset.vocabulary].push(checkbox.id)
                    selectedFilterElements.push(checkbox)
                }
            }
        }
        // Filter by vocabulary
        this.filterByVocabulary(filterVocabulary, selectedFilterElements)
    }

    /**
     * Filter job posting by given vocabulary
     * @param filterVocabulary
     * @param selectedFilterElements
     */
    filterByVocabulary(filterVocabulary, selectedFilterElements) {
        let filterVocabularyIterator = Object.keys(filterVocabulary)
        // reset every time we filter
        for (let jobItem of this.jobItems) {
            jobItem.setAttribute('style', 'display:none')
            jobItem.dataset.filtered = 'false'
        }

        if (selectedFilterElements.length === 0) {
            for (let jobItem of this.jobItems) {
                jobItem.setAttribute('style', 'display:block')
            }
        } else {
            for (const key of filterVocabularyIterator) {
                this.filterByTags(this.jobItems, filterVocabulary[key], key)
            }
        }
    }

    /**
     * Filter by a specific group
     * If dataset is undefined (not set) we also render the job no matter if its filtered or not
     * @param allJobs
     * @param filterTags
     * @param key
     */
    filterByTags(allJobs, filterTags, key) {
        let showJob = false
        for (let i = 0; i < allJobs.length; i++) {
            showJob = false
            // value of dataset could be comma separated so split and check
            let dataToCheck = allJobs[i].dataset[key.toLowerCase()]
            if (dataToCheck) {
                dataToCheck.split(this.multiValueSeparator).forEach(function (possibleOccurrence) {
                    if (filterTags.includes(possibleOccurrence)) showJob = true
                })
            }
            // validation and setting properties
            if (showJob === true && allJobs[i].dataset.filtered !== 'true') {
                allJobs[i].style.display = 'block'
            } else {
                allJobs[i].style.display = 'none'
                allJobs[i].dataset.filtered = 'true'
            }
        }
    }

    /**
     * Create a html element from string
     * @param htmlString
     * @returns {ChildNode}
     */
    createElementFromHTML(htmlString) {
        var div = document.createElement('div')
        div.innerHTML = htmlString.trim()
        return div.firstChild
    }
}
